var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.leaves != null)?_c('div',[_vm._v(" "+_vm._s(this.leaves.leavesAvailed)+" / "+_vm._s(this.leaves.monthlyMaximumLeaves)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }